import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 🚀 这里的逻辑就是把 App.js 里的【放克热狗社区】注入到那个黄色的 id="root" 盒子里
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);